import Icon from 'flarum/common/components/Icon';
import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import LinkGuardDestination from '../components/LinkGuardDestination';
import { parseLinkGuardTarget } from '../utils/linkGuardUrl';
import warningContent from '../utils/warningContent';
export default class LinkGuardPage extends Page {
  bodyClass = 'App--linkGuard';
  target = null;
  targetHash = '';
  closeRequested = false;
  oninit(vnode) {
    super.oninit(vnode);
    this.readTarget();
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    app.setTitle(app.translator.trans('ffans-link-guard.forum.page_title', {}, true));
    app.setTitleCount(0);
    window.addEventListener('hashchange', this.onHashChange);
  }
  onremove(vnode) {
    window.removeEventListener('hashchange', this.onHashChange);
    super.onremove(vnode);
  }
  onHashChange = () => {
    this.readTarget();
    m.redraw();
  };
  readTarget() {
    this.targetHash = window.location.hash;
    this.target = parseLinkGuardTarget(this.targetHash);
  }
  view() {
    // A route redraw can reuse the Page before the hashchange event is dispatched.
    if (this.targetHash !== window.location.hash) this.readTarget();
    const {
      forumName,
      title,
      message
    } = warningContent();
    const logoUrl = app.forum.attribute('logoUrl');
    const darkLogoUrl = app.forum.attribute('logoDarkModeUrl');
    return m("div", {
      className: "LinkGuardPage"
    }, m("div", {
      className: "LinkGuardPage-content"
    }, m("div", {
      className: "LinkGuardPage-brand"
    }, logoUrl ? m('[', null, m("img", {
      className: "Header-logo",
      src: logoUrl,
      alt: forumName
    }), darkLogoUrl && m("img", {
      className: "Header-logo Header-logo--dark-mode",
      src: darkLogoUrl,
      alt: forumName
    })) : forumName), m("section", {
      className: `LinkGuardPage-notice${this.target ? '' : ' LinkGuardPage-invalid'}`,
      "aria-labelledby": "LinkGuardPage-title"
    }, m("h1", {
      id: "LinkGuardPage-title"
    }, this.target ? title : app.translator.trans('ffans-link-guard.forum.invalid_title')), m("p", {
      className: "LinkGuardPage-message"
    }, this.target ? message : app.translator.trans('ffans-link-guard.forum.invalid_message')), this.target && m(LinkGuardDestination, {
      target: this.target
    }), m("div", {
      className: "LinkGuardPage-actions"
    }, m("button", {
      className: "Button Button--outline",
      type: "button",
      onclick: () => {
        this.closeRequested = true;
        window.close();
      }
    }, app.translator.trans('ffans-link-guard.forum.close_button')), this.target && m("a", {
      className: "Button Button--primary",
      href: this.target.href,
      target: "_self",
      rel: "nofollow noopener noreferrer external",
      "data-ffans-link-guard-bypass": "1"
    }, app.translator.trans('ffans-link-guard.forum.continue_button'), m(Icon, {
      name: "fas fa-arrow-up-right-from-square"
    }))), this.closeRequested && m("p", {
      role: "status",
      className: "LinkGuardPage-footer"
    }, app.translator.trans('ffans-link-guard.forum.close_fallback', {
      a: _ref => {
        let {
          children
        } = _ref;
        return m("a", {
          href: this.backUrl()
        }, children);
      }
    })))));
  }
  backUrl() {
    try {
      const referrer = new URL(document.referrer);
      if (referrer.origin === new URL(app.forum.attribute('baseUrl')).origin) return referrer.href;
    } catch {
      // Missing or malformed referrers use the configured forum homepage.
    }
    return app.route('index');
  }
}
flarum.reg.add('ffans-link-guard', 'forum/pages/LinkGuardPage', LinkGuardPage);